var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSugarGliderSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_197_177738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.5 319C219.423 319 268 312.294 268 304.023C268 295.751 219.423 289.046 159.5 289.046C99.5771 289.046 51 295.751 51 304.023C51 312.294 99.5771 319 159.5 319Z",
    fill: "#EDB27C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.62 255.913C257.131 254.935 256.46 253.957 255.605 253.163C254.75 252.368 253.773 251.634 252.674 251.084C251.575 250.534 250.354 250.167 249.011 249.923C249.011 249.923 243.027 248.211 231.548 254.263C226.297 257.014 220.558 258.848 214.635 259.214C207.858 259.642 199.309 258.725 190.456 253.835L188.197 252.429L187.342 254.752L185.816 256.891C185.327 257.503 184.9 258.053 184.411 258.603C183.923 259.153 183.373 259.703 182.641 260.376C183.373 261.232 184.106 262.026 184.9 262.821C185.694 263.616 186.487 264.349 187.342 265.144C188.197 265.878 189.113 266.611 190.029 267.345C190.945 268.078 191.921 268.751 192.959 269.423C193.936 270.096 195.035 270.707 196.073 271.318C197.172 271.93 198.271 272.541 199.432 273.091C200.592 273.641 201.752 274.13 202.973 274.619C204.011 275.047 205.11 275.414 206.209 275.781C207.308 276.148 208.407 276.453 209.506 276.759C210.605 277.065 211.765 277.309 212.925 277.554C214.085 277.798 215.246 277.981 216.406 278.165C217.566 278.348 218.726 278.471 219.947 278.593C221.107 278.715 222.328 278.776 223.488 278.837C224.648 278.898 225.87 278.898 227.03 278.898C228.19 278.898 229.35 278.837 230.51 278.776C231.792 278.715 233.074 278.593 234.357 278.409C235.639 278.226 236.86 278.043 238.142 277.798C239.363 277.554 240.585 277.248 241.745 276.942C242.905 276.637 244.004 276.27 245.103 275.842C246.202 275.414 247.24 274.986 248.217 274.497C249.194 274.008 250.11 273.458 250.964 272.908C252.002 272.235 252.979 271.502 253.834 270.707C254.689 269.912 255.422 269.056 256.093 268.201C256.704 267.284 257.253 266.367 257.681 265.389C258.108 264.411 258.352 263.432 258.536 262.393C258.719 261.354 258.719 260.315 258.597 259.214C258.475 257.931 258.108 256.891 257.62 255.913Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.665 253.102C254.81 252.307 253.833 251.573 252.734 251.023C251.635 250.473 250.414 250.106 249.071 249.862C249.071 249.862 243.453 248.272 232.707 253.652C236.065 254.936 240.278 257.381 242.415 261.599C242.659 262.088 242.11 262.577 241.683 262.271L239.179 260.743C239.179 260.743 245.224 266.428 243.026 276.392C243.759 276.148 244.491 275.903 245.163 275.659C246.262 275.231 247.3 274.803 248.277 274.314C249.254 273.825 250.17 273.275 251.024 272.725C252.062 272.052 253.039 271.319 253.894 270.524C254.749 269.729 255.482 268.873 256.153 268.018C256.764 267.101 257.313 266.184 257.741 265.206C258.168 264.227 258.412 263.249 258.596 262.21C258.779 261.171 258.779 260.132 258.657 259.031C258.535 257.931 258.229 256.892 257.68 255.914C257.13 254.875 256.459 253.958 255.665 253.102Z",
    fill: "#332D31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.62 255.914C257.131 254.936 256.46 253.958 255.605 253.163C254.811 252.369 253.895 251.696 252.857 251.207C252.979 251.329 253.163 251.452 253.285 251.574C254.078 252.369 254.75 253.347 255.239 254.325C255.727 255.303 256.032 256.403 256.154 257.442C256.277 258.543 256.277 259.582 256.093 260.621C255.971 261.66 255.666 262.638 255.3 263.616C254.933 264.595 254.384 265.512 253.773 266.367C253.163 267.223 252.43 268.079 251.575 268.874C250.72 269.668 249.804 270.402 248.766 271.074C247.912 271.625 246.996 272.175 246.019 272.664C245.042 273.153 244.065 273.581 242.966 274.009C241.928 274.437 240.829 274.803 239.669 275.109C238.509 275.415 237.349 275.72 236.127 275.965C234.906 276.209 233.685 276.393 232.464 276.576C231.243 276.76 229.961 276.821 228.678 276.943C227.518 277.004 226.419 277.065 225.259 277.065C224.099 277.065 222.939 277.065 221.779 277.004C220.619 276.943 219.459 276.882 218.298 276.76C217.138 276.637 215.978 276.515 214.818 276.332C213.658 276.148 212.498 275.965 211.399 275.72C210.3 275.476 209.14 275.231 208.041 274.926C206.942 274.62 205.843 274.314 204.744 273.948C203.645 273.581 202.607 273.214 201.569 272.786C200.408 272.297 199.248 271.808 198.088 271.258C196.989 270.708 195.89 270.096 194.791 269.485C193.753 268.874 192.715 268.201 191.738 267.59C190.761 266.918 189.784 266.245 188.869 265.512C187.953 264.778 187.098 264.044 186.243 263.311C185.388 262.577 184.594 261.783 183.801 260.988C183.495 260.682 183.251 260.377 182.946 260.071C182.824 260.193 182.763 260.254 182.641 260.377C183.373 261.232 184.106 262.027 184.9 262.822C185.694 263.616 186.487 264.35 187.342 265.145C188.197 265.878 189.113 266.612 190.029 267.345C190.945 268.079 191.921 268.751 192.959 269.424C193.936 270.096 195.035 270.708 196.073 271.319C197.172 271.93 198.271 272.542 199.432 273.092C200.592 273.642 201.752 274.131 202.973 274.62C204.011 275.048 205.11 275.415 206.209 275.781C207.308 276.148 208.407 276.454 209.506 276.76C210.605 277.065 211.765 277.31 212.925 277.554C214.085 277.799 215.246 277.982 216.406 278.166C217.566 278.349 218.726 278.471 219.947 278.593C221.107 278.716 222.328 278.777 223.488 278.838C224.648 278.899 225.87 278.899 227.03 278.899C228.19 278.899 229.35 278.838 230.51 278.777C231.792 278.716 233.074 278.593 234.357 278.41C235.639 278.227 236.86 278.043 238.142 277.799C239.363 277.554 240.585 277.249 241.745 276.943C242.905 276.637 244.004 276.27 245.103 275.843C246.202 275.415 247.24 274.987 248.217 274.498C249.194 274.009 250.11 273.458 250.964 272.908C252.002 272.236 252.979 271.502 253.834 270.708C254.689 269.913 255.422 269.057 256.093 268.201C256.704 267.284 257.253 266.367 257.681 265.389C258.108 264.411 258.352 263.433 258.536 262.394C258.719 261.355 258.719 260.315 258.597 259.215C258.475 257.931 258.108 256.892 257.62 255.914Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.426 157.249V243.993L120.913 280.366C120.913 280.366 72.4329 248.333 75.9132 192.338L116.639 157.249H157.426Z",
    fill: "url(#paint0_linear_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.0257 189.587L75.8507 192.338C72.3704 248.333 120.85 280.365 120.85 280.365L122.133 279.082C82.2007 249.128 77.9266 208.904 79.0257 189.587Z",
    fill: "url(#paint1_linear_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.426 157.249V243.993L194 280.366C194 280.366 242.48 248.333 238.999 192.338L198.274 157.249H157.426Z",
    fill: "url(#paint2_linear_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.826 189.587L239.001 192.338C242.481 248.333 194.001 280.365 194.001 280.365L192.719 279.082C232.651 249.128 236.986 208.904 235.826 189.587Z",
    fill: "url(#paint3_linear_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.9443 184.147L68.7692 183.291C68.7692 183.291 58.2062 186.348 55.0312 193.989C52.5278 199.857 59.5495 206.154 64.5562 203.953C69.563 201.752 71.2726 197.168 71.2726 197.168L71.5168 198.818C71.8832 199.98 73.4707 200.224 74.0813 199.185C74.875 197.901 75.6688 195.762 75.852 192.277C76.2794 184.758 71.9443 184.147 71.9443 184.147Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.179 134.02C106.137 148.569 85.5605 164.951 68.7695 183.291L75.8523 192.338C96.673 181.579 120.302 168.497 145.092 154.498L128.179 134.02Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2494 199.796C72.1884 199.735 72.0663 199.674 72.0052 199.613C72.1273 199.368 72.1884 199.246 72.1884 199.246L72.2494 199.796ZM56.008 200.958C55.3364 199.307 55.2143 197.412 56.0691 195.639C59.4883 188.059 70.1124 185.308 70.1124 185.308C86.7812 168.008 109.128 150.953 130.804 137.199L128.24 134.081C106.198 148.63 85.6211 165.013 68.8302 183.352C68.8302 183.352 58.2672 186.409 55.0921 194.05C53.932 196.495 54.6037 199.001 56.008 200.958Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9443 184.147L68.7692 183.291C68.7692 183.291 58.2062 186.348 55.0312 193.989C52.5278 199.857 59.5495 206.154 64.5562 203.953C69.563 201.752 71.2726 197.168 71.2726 197.168L71.5168 198.818C71.8832 199.98 73.4707 200.224 74.0813 199.185C74.875 197.901 75.6688 195.762 75.852 192.277C76.2794 184.758 71.9443 184.147 71.9443 184.147Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.179 134.02C106.137 148.569 85.5605 164.951 68.7695 183.291L75.8523 192.338C96.673 181.579 120.302 168.497 145.092 154.498L128.179 134.02Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M72.2494 199.796C72.1884 199.735 72.0663 199.674 72.0052 199.613C72.1273 199.368 72.1884 199.246 72.1884 199.246L72.2494 199.796ZM56.008 200.958C55.3364 199.307 55.2143 197.412 56.0691 195.639C59.4883 188.059 70.1124 185.308 70.1124 185.308C86.7812 168.008 109.128 150.953 130.804 137.199L128.24 134.081C106.198 148.63 85.6211 165.013 68.8302 183.352C68.8302 183.352 58.2672 186.409 55.0921 194.05C53.932 196.495 54.6037 199.001 56.008 200.958Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.457 184.147L246.632 183.291C246.632 183.291 257.195 186.348 260.37 193.989C262.873 199.857 255.852 206.154 250.845 203.953C245.838 201.752 244.129 197.168 244.129 197.168L243.884 198.818C243.518 199.98 241.93 200.224 241.32 199.185C240.526 197.901 239.732 195.762 239.549 192.277C239.122 184.758 243.457 184.147 243.457 184.147Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.222 134.02C209.264 148.569 229.84 164.951 246.631 183.291L239.548 192.338C218.728 181.579 195.098 168.497 170.309 154.498L187.222 134.02Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M243.212 199.246C243.212 199.246 243.273 199.368 243.395 199.613C243.334 199.674 243.212 199.735 243.151 199.796L243.212 199.246ZM260.431 194.05C257.195 186.409 246.693 183.352 246.693 183.352C229.841 164.952 209.325 148.63 187.283 134.081L184.719 137.199C206.394 150.953 228.742 168.008 245.41 185.308C245.41 185.308 256.034 188.12 259.454 195.639C260.247 197.473 260.186 199.307 259.515 200.958C260.858 199.001 261.469 196.495 260.431 194.05Z",
    fill: "#F95858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.457 184.147L246.632 183.291C246.632 183.291 257.195 186.348 260.37 193.989C262.873 199.857 255.852 206.154 250.845 203.953C245.838 201.752 244.129 197.168 244.129 197.168L243.884 198.818C243.518 199.98 241.93 200.224 241.32 199.185C240.526 197.901 239.732 195.762 239.549 192.277C239.122 184.758 243.457 184.147 243.457 184.147Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.222 134.02C209.264 148.569 229.84 164.951 246.631 183.291L239.548 192.338C218.728 181.579 195.098 168.497 170.309 154.498L187.222 134.02Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M243.212 199.246C243.212 199.246 243.273 199.368 243.395 199.613C243.334 199.674 243.212 199.735 243.151 199.796L243.212 199.246ZM260.431 194.05C257.195 186.409 246.693 183.352 246.693 183.352C229.841 164.952 209.325 148.63 187.283 134.081L184.719 137.199C206.394 150.953 228.742 168.008 245.41 185.308C245.41 185.308 256.034 188.12 259.454 195.639C260.247 197.473 260.186 199.307 259.515 200.958C260.858 199.001 261.469 196.495 260.431 194.05Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.607 295.159C103.02 289.291 110.164 283.422 120.849 280.305H134.404C131.9 292.836 117.307 302.373 108.698 299.438C106.744 298.766 105.157 297.177 104.607 295.159Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.571 280.366C128.908 291.675 115.536 299.928 107.477 297.177C106.378 296.81 105.462 296.138 104.668 295.282C105.217 297.238 106.805 298.828 108.759 299.5C117.429 302.495 132.022 292.898 134.464 280.366H132.571Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.169 229.811C213.169 229.261 213.108 228.65 213.108 228.1C212.986 225.899 212.803 223.698 212.497 221.498C212.436 220.947 212.375 220.397 212.253 219.786C212.192 219.236 212.07 218.686 212.009 218.135C211.948 217.585 211.826 217.035 211.765 216.485C211.642 215.935 211.581 215.384 211.459 214.895C211.337 214.345 211.215 213.795 211.154 213.184C211.032 212.634 210.91 212.083 210.788 211.533C210.665 210.983 210.543 210.433 210.421 209.883C210.238 209.21 210.116 208.477 209.933 207.804C209.872 207.376 209.75 207.01 209.689 206.582C202.911 179.073 188.99 153.215 190.883 135.609H157.423H123.963C125.856 153.215 111.935 179.012 105.157 206.582C105.096 207.01 104.974 207.376 104.913 207.804C104.73 208.477 104.608 209.21 104.425 209.883C104.303 210.433 104.18 210.983 104.058 211.533C103.936 212.083 103.814 212.634 103.692 213.184C103.57 213.734 103.448 214.284 103.387 214.895C103.265 215.446 103.203 215.996 103.081 216.485C102.959 217.035 102.898 217.585 102.837 218.135C102.776 218.686 102.654 219.236 102.593 219.786C102.532 220.336 102.41 220.886 102.349 221.498C102.043 223.698 101.86 225.899 101.738 228.1C101.677 228.65 101.677 229.261 101.677 229.811C101.005 247.233 105.524 264.594 120.849 280.366H134.404C134.587 267.345 142.952 259.398 157.423 259.337C171.894 259.337 180.259 267.345 180.442 280.366H193.997C209.322 264.594 213.841 247.172 213.169 229.811Z",
    fill: "#635D5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M213.17 229.811C213.17 229.261 213.109 228.65 213.109 228.1C212.987 225.899 212.804 223.698 212.498 221.498C212.437 220.947 212.376 220.397 212.254 219.786C212.193 219.236 212.071 218.686 212.01 218.135C211.949 217.585 211.827 217.035 211.766 216.485C211.643 215.935 211.582 215.384 211.46 214.895C211.338 214.345 211.216 213.795 211.155 213.184C211.033 212.634 210.911 212.083 210.789 211.533C210.666 210.983 210.544 210.433 210.422 209.883C210.239 209.21 210.117 208.477 209.934 207.804C209.873 207.376 209.751 207.01 209.69 206.582C202.912 179.073 188.991 153.215 190.884 135.609H186.61C185.45 153.521 198.882 179.195 205.538 206.521C205.599 206.948 205.721 207.315 205.782 207.743C205.965 208.477 206.087 209.149 206.27 209.883C206.392 210.433 206.515 210.983 206.637 211.533C206.759 212.083 206.881 212.634 207.003 213.184C207.125 213.734 207.247 214.345 207.308 214.895C207.43 215.446 207.491 215.996 207.614 216.546C207.736 217.096 207.797 217.646 207.858 218.196C207.919 218.747 208.041 219.297 208.102 219.908C208.163 220.458 208.285 221.07 208.346 221.62C208.652 223.882 208.835 226.082 208.957 228.344C209.018 228.894 209.018 229.506 209.018 230.056C209.69 247.295 205.415 264.533 191.067 280.244H194.059C209.323 264.594 213.841 247.172 213.17 229.811Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.909 280.366H123.901C109.552 264.655 105.278 247.417 105.949 230.178C105.949 229.628 106.011 229.016 106.011 228.466C106.133 226.204 106.316 224.004 106.621 221.742C106.682 221.192 106.743 220.58 106.865 220.03C106.926 219.48 107.049 218.93 107.11 218.319C107.171 217.768 107.293 217.218 107.354 216.668C107.476 216.118 107.537 215.568 107.659 215.017C107.781 214.467 107.903 213.856 107.964 213.306C108.087 212.756 108.209 212.205 108.331 211.655C108.453 211.105 108.575 210.555 108.697 210.005C108.88 209.271 109.002 208.599 109.186 207.865C109.247 207.437 109.369 207.071 109.43 206.643C116.085 179.256 129.457 153.582 128.358 135.731H124.084C125.976 153.337 112.055 179.134 105.278 206.704C105.217 207.132 105.095 207.498 105.034 207.926C104.85 208.599 104.728 209.332 104.545 210.005C104.423 210.555 104.301 211.105 104.179 211.655C104.057 212.205 103.935 212.756 103.812 213.306C103.69 213.856 103.568 214.406 103.507 215.017C103.385 215.568 103.324 216.118 103.202 216.607C103.08 217.157 103.019 217.707 102.958 218.257C102.897 218.808 102.774 219.358 102.713 219.908C102.652 220.458 102.53 221.008 102.469 221.62C102.164 223.82 101.981 226.021 101.859 228.222C101.798 228.772 101.798 229.383 101.798 229.933C101.065 247.172 105.583 264.594 120.909 280.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.238 295.159C211.825 289.291 204.681 283.422 193.996 280.305H180.441C182.945 292.836 197.538 302.373 206.147 299.438C208.101 298.766 209.688 297.177 210.238 295.159Z",
    fill: "#FF669A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.334 280.366C185.998 291.675 199.369 299.928 207.429 297.177C208.528 296.81 209.444 296.138 210.238 295.282C209.688 297.238 208.101 298.828 206.147 299.5C197.477 302.495 182.884 292.898 180.441 280.366H182.334Z",
    fill: "#334E60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.104 204.32C191.921 174.183 178.732 159.023 179.282 135.671H157.423H135.564C136.114 158.962 122.986 174.183 122.742 204.32C122.742 204.626 122.742 204.87 122.742 205.176C122.742 223.148 138.251 237.759 157.423 237.759C176.595 237.759 192.104 223.148 192.104 205.176C192.104 204.87 192.104 204.626 192.104 204.32Z",
    fill: "url(#paint4_radial_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.603 56.9953L213.658 51.677L200.408 37.4336L188.074 24.1072C198.515 2.40594 222.633 -4.37952 231.12 5.3402C242.965 18.9111 234.295 46.1141 218.603 56.9953Z",
    fill: "url(#paint5_radial_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.659 51.6767L200.409 37.4333C201.386 37.8001 202.302 38.228 203.218 38.6559C204.134 39.0838 205.172 39.634 206.088 38.9004C206.576 38.5337 206.82 37.8612 206.759 37.1888C206.637 35.8439 205.599 34.927 204.561 34.1323L208.408 33.7044C209.385 33.5821 209.873 32.3595 209.202 31.6259C208.408 30.8312 207.431 30.2199 206.332 29.8531C204.561 29.2418 202.668 29.2418 200.837 29.2418C202.485 28.6917 204.195 28.1415 205.904 27.5913C206.393 27.4079 206.881 27.2245 207.126 26.7966C207.37 26.3076 207.065 25.6352 206.637 25.2684C206.149 24.9016 205.538 24.8405 204.989 24.7793C202.974 24.5959 200.898 24.6571 198.883 25.0238C206.698 12.6144 219.887 5.15649 225.931 9.92466C235.579 20.1946 223.001 44.4633 213.659 51.6767Z",
    fill: "url(#paint6_linear_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.999 36.3943C226.97 45.3194 220.803 52.3493 206.088 37.9837C197.906 29.9756 189.053 24.2294 188.259 23.8015C188.198 23.9237 188.137 23.9849 188.137 24.046L200.47 37.3724L213.72 51.6158L218.666 56.9341C233.564 46.6642 242.112 21.4785 232.648 7.35742C236.617 16.0379 234.48 28.6919 230.999 36.3943Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.302 56.9953L101.248 51.677L114.497 37.4336L126.831 24.1072C116.39 2.40594 92.2111 -4.37952 83.7851 5.3402C71.9399 18.9111 80.6101 46.1141 96.302 56.9953Z",
    fill: "url(#paint7_radial_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.25 51.6767L114.499 37.4333C113.522 37.8001 112.606 38.228 111.691 38.6559C110.775 39.0838 109.737 39.634 108.821 38.9004C108.332 38.5337 108.088 37.8612 108.149 37.1888C108.271 35.8439 109.309 34.927 110.347 34.1323L106.501 33.7044C105.524 33.5821 105.035 32.3595 105.707 31.6259C106.501 30.8312 107.478 30.2199 108.577 29.8531C110.347 29.2418 112.24 29.2418 114.072 29.2418C112.423 28.6917 110.714 28.1415 109.004 27.5913C108.516 27.4079 108.027 27.2245 107.783 26.7966C107.539 26.3076 107.844 25.6352 108.271 25.2684C108.76 24.9016 109.37 24.8405 109.92 24.7793C111.935 24.5959 114.011 24.6571 116.026 25.0238C108.149 12.6144 94.9607 5.15649 88.977 9.92466C79.2688 20.1946 91.9078 44.4633 101.25 51.6767Z",
    fill: "url(#paint8_linear_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.9083 36.3943C87.9381 45.3194 94.1049 52.3493 108.82 37.9837C117.002 29.9756 125.855 24.2294 126.649 23.8015C126.71 23.9237 126.771 23.9849 126.771 24.046L114.437 37.3724L101.249 51.6769L96.303 56.9953C81.3438 46.6642 72.7957 21.4785 82.1986 7.35742C78.2909 16.0379 80.428 28.6919 83.9083 36.3943Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.968 63.3533C207.002 40.3072 190.455 14.877 157.973 14.877C157.789 14.877 157.606 14.877 157.423 14.877C157.24 14.877 157.057 14.877 156.874 14.877C124.391 14.877 107.905 40.3072 87.878 63.3533C66.3856 89.1503 83.2376 113.725 90.6256 120.755C108.088 137.382 133.488 146.674 157.484 146.735C181.48 146.674 206.819 137.321 224.343 120.755C231.67 113.786 248.46 89.2114 226.968 63.3533Z",
    fill: "url(#paint9_radial_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.41 87.377C237.41 87.7437 237.471 88.1716 237.471 88.5384C237.471 88.1716 237.471 87.8049 237.41 87.377Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.164 85.0537C237.225 85.7261 237.347 86.3986 237.408 87.0099C237.347 86.3374 237.286 85.665 237.164 85.0537Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.021 122.833C221.838 123.016 221.593 123.2 221.41 123.322C221.593 123.139 221.777 123.016 222.021 122.833Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.41 87.133C237.41 87.0719 237.41 87.0107 237.41 87.0107C237.41 87.133 237.41 87.2553 237.471 87.4387C237.41 87.3164 237.41 87.2553 237.41 87.133Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.167 84.8705C237.167 84.8094 237.167 84.6871 237.105 84.626C237.105 84.7482 237.167 84.9316 237.167 85.0539C237.167 84.9928 237.167 84.9316 237.167 84.8705Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.042 84.0762C237.042 83.9539 236.98 83.8928 236.98 83.7705C237.042 83.9539 237.042 84.1984 237.103 84.3818C237.042 84.2596 237.042 84.1984 237.042 84.0762Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.099 120.938C223.428 121.61 222.695 122.221 222.023 122.833C222.695 122.221 223.428 121.549 224.099 120.938Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.381 119.654L225.32 119.715C225.32 119.715 225.381 119.715 225.381 119.654Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.319 119.715C225.136 119.898 224.953 120.082 224.77 120.265C224.953 120.143 225.136 119.959 225.319 119.715Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.53 91.4727C237.53 91.8394 237.53 92.2062 237.469 92.5119C237.469 92.2062 237.469 91.8394 237.53 91.4727Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.09 117.759C226.968 117.881 226.907 118.003 226.785 118.126C226.846 118.003 226.968 117.881 227.09 117.759Z",
    fill: "#E0865A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.211 117.514C227.455 117.208 227.699 116.964 227.882 116.658C227.577 117.025 227.272 117.392 227.027 117.759C227.149 117.697 227.149 117.636 227.211 117.514Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.783 118.126C226.295 118.676 225.867 119.226 225.379 119.654C225.806 119.165 226.295 118.676 226.783 118.126Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.167 114.947L229.105 115.008C229.167 115.008 229.167 115.008 229.167 114.947Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.991 106.45C233.991 106.45 233.991 106.511 233.93 106.511C233.991 106.511 233.991 106.511 233.991 106.45Z",
    fill: "#F9B9A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.282 120.754C206.819 137.382 181.419 146.673 157.423 146.735C133.427 146.673 108.088 137.321 90.5646 120.754C85.1304 115.558 74.5064 100.887 77.9867 83.1591C86.5958 67.3263 106.623 69.5881 120.239 81.264C122.193 82.9146 124.024 84.5039 125.856 85.9711C126.039 86.0933 138.251 95.4463 144.54 89.4555C152.599 81.8142 142.891 36.5166 126.589 23.7404C130.191 21.4174 134.038 19.4613 138.19 17.9941C144.601 31.6262 154.553 60.1741 154.981 84.8707C154.981 84.9319 154.981 84.993 154.981 85.1152C154.981 93.0011 157.362 92.512 157.362 92.512C157.362 92.512 159.743 93.0011 159.743 85.1152C159.743 85.0541 159.743 84.9319 159.743 84.8707C160.171 60.2352 170.123 31.6262 176.534 17.9941C180.686 19.4613 184.533 21.4174 188.135 23.7404C171.894 36.5166 162.125 81.8142 170.184 89.4555C176.473 95.3851 188.685 86.0933 188.868 85.9711C190.7 84.4428 192.531 82.9146 194.485 81.264C208.101 69.5881 228.189 67.3263 236.737 83.1591C240.279 100.887 229.716 115.619 224.282 120.754Z",
    fill: "url(#paint10_radial_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.328 67.8154C241.502 90.128 228.13 109.995 221.841 116.231C204.989 132.858 180.505 142.15 157.425 142.211C134.284 142.15 109.861 132.797 93.0088 116.231C86.7199 110.056 73.3482 90.1891 84.5218 67.8154C68.2804 91.9619 83.6059 114.152 90.6276 120.754C108.09 137.382 133.49 146.674 157.486 146.735C181.482 146.674 206.821 137.321 224.345 120.754C231.244 114.152 246.57 91.9619 230.328 67.8154Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.246 93.6129C170.246 98.0142 162.186 103.455 157.424 103.455C152.295 103.455 144.602 97.9531 144.602 93.6129C144.602 89.2726 153.943 87.9277 157.424 87.9277C160.904 87.9889 170.246 89.2726 170.246 93.6129Z",
    fill: "url(#paint11_linear_197_177738)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.423 92.0851C160.323 92.0851 162.674 91.6472 162.674 91.107C162.674 90.5668 160.323 90.1289 157.423 90.1289C154.523 90.1289 152.172 90.5668 152.172 91.107C152.172 91.6472 154.523 92.0851 157.423 92.0851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.513 62.7415C198.513 68.9768 193.446 74.0506 187.218 74.0506C180.99 74.0506 175.922 68.9768 175.922 62.7415C175.922 60.0518 176.838 57.6066 178.425 55.6504C179.097 56.2006 179.83 56.7507 180.623 57.2398C182.76 58.5846 185.508 59.8073 188.561 60.6631C189.171 60.8465 189.721 60.9687 190.332 61.091C191.37 61.3355 192.469 61.5189 193.446 61.6412C194.239 61.7634 195.094 61.8246 195.827 61.8857C196.804 61.9468 197.72 61.9468 198.574 61.8857C198.513 62.1913 198.513 62.4359 198.513 62.7415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.765 62.742C195.765 67.5101 191.919 71.3613 187.156 71.3613C182.394 71.3613 178.547 67.5101 178.547 62.742C178.547 60.6635 179.28 58.7685 180.501 57.2402C182.638 58.5851 185.385 59.8077 188.438 60.6635C189.049 60.8469 189.598 60.9692 190.209 61.0914C191.247 61.336 192.346 61.5194 193.323 61.6416C194.117 61.7639 194.971 61.825 195.704 61.8861C195.765 62.1918 195.765 62.4974 195.765 62.742Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.325 61.7025C193.203 62.9251 192.714 63.8421 192.104 63.9032C191.31 64.0255 190.516 62.8029 190.211 61.1523C191.31 61.3969 192.348 61.5803 193.325 61.7025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.616 67.8153C192.29 67.8153 192.837 67.268 192.837 66.5927C192.837 65.9175 192.29 65.3701 191.616 65.3701C190.941 65.3701 190.395 65.9175 190.395 66.5927C190.395 67.268 190.941 67.8153 191.616 67.8153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.331 62.7415C116.331 68.9768 121.398 74.0506 127.626 74.0506C133.854 74.0506 138.922 68.9768 138.922 62.7415C138.922 60.0518 138.006 57.6066 136.419 55.6504C135.747 56.2006 135.014 56.7507 134.221 57.2398C132.084 58.5846 129.336 59.8073 126.283 60.6631C125.672 60.8465 125.123 60.9687 124.512 61.091C123.474 61.3355 122.375 61.5189 121.398 61.6412C120.605 61.7634 119.75 61.8246 119.017 61.8857C118.04 61.9468 117.124 61.9468 116.27 61.8857C116.331 62.1913 116.331 62.4359 116.331 62.7415Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.078 62.742C119.078 67.5101 122.925 71.3613 127.687 71.3613C132.45 71.3613 136.296 67.5101 136.296 62.742C136.296 60.6635 135.564 58.7685 134.343 57.2402C132.206 58.5851 129.458 59.8077 126.405 60.6635C125.795 60.8469 125.245 60.9692 124.634 61.0914C123.596 61.336 122.497 61.5194 121.52 61.6416C120.727 61.7639 119.872 61.825 119.139 61.8861C119.078 62.1918 119.078 62.4974 119.078 62.742Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.52 61.7025C121.642 62.9251 122.13 63.8421 122.741 63.9032C123.534 64.0255 124.328 62.8029 124.633 61.1523C123.534 61.3969 122.496 61.5803 121.52 61.7025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.291 67.8153C123.966 67.8153 124.513 67.268 124.513 66.5927C124.513 65.9175 123.966 65.3701 123.291 65.3701C122.617 65.3701 122.07 65.9175 122.07 66.5927C122.07 67.268 122.617 67.8153 123.291 67.8153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.361 112.746C158.582 112.807 159.803 112.99 160.902 113.296C162.002 113.602 163.04 114.091 163.955 114.58C164.871 115.069 165.665 115.68 166.398 116.291C167.069 116.903 167.68 117.575 168.168 118.186C169.145 119.47 169.634 120.632 169.878 121.426C170.122 122.282 170.122 122.771 170 122.771C169.634 122.893 168.901 121.182 166.886 119.226C166.398 118.737 165.787 118.247 165.177 117.758C164.505 117.269 163.772 116.841 162.978 116.414C162.185 116.047 161.269 115.68 160.292 115.435C159.315 115.191 158.338 115.069 157.3 115.008C155.224 114.946 153.27 115.435 151.683 116.169C150.095 116.964 148.813 118.064 147.897 119.103C146.065 121.243 145.272 122.955 144.966 122.832C144.722 122.771 144.905 120.815 146.615 118.125C147.47 116.841 148.874 115.435 150.706 114.335C152.538 113.296 154.858 112.623 157.361 112.746Z",
    fill: "#B28560"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.341 82.4868C200.973 82.4868 205.538 79.8868 205.538 76.6795C205.538 73.4721 200.973 70.8721 195.341 70.8721C189.71 70.8721 185.145 73.4721 185.145 76.6795C185.145 79.8868 189.71 82.4868 195.341 82.4868Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M205.111 75.0898C205.111 78.2686 200.653 81.0806 195.097 81.4474C191.006 81.6919 187.465 80.5916 185.816 78.6965C187.221 80.8972 190.945 82.4866 195.341 82.4866C200.959 82.4866 205.538 79.858 205.538 76.6792C205.538 76.1291 205.355 75.5789 205.111 75.0898Z",
    fill: "#4D4440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.975 74.5109C192.216 74.1897 193.125 73.5583 193.007 73.1007C192.889 72.6432 191.787 72.5326 190.547 72.8539C189.306 73.1751 188.397 73.8065 188.515 74.2641C188.633 74.7217 189.735 74.8322 190.975 74.5109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.505 82.4868C125.137 82.4868 129.702 79.8868 129.702 76.6795C129.702 73.4721 125.137 70.8721 119.505 70.8721C113.874 70.8721 109.309 73.4721 109.309 76.6795C109.309 79.8868 113.874 82.4868 119.505 82.4868Z",
    fill: "#00AEEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M109.736 75.0898C109.736 78.2686 114.193 81.0806 119.75 81.4474C123.84 81.6919 127.382 80.5916 129.03 78.6965C127.626 80.8972 123.901 82.4866 119.505 82.4866C113.888 82.4866 109.309 79.858 109.309 76.6792C109.37 76.1291 109.492 75.5789 109.736 75.0898Z",
    fill: "#4D4440"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.363 74.2577C126.481 73.8001 125.571 73.1687 124.331 72.8475C123.09 72.5262 121.989 72.6368 121.87 73.0943C121.752 73.5519 122.662 74.1833 123.902 74.5045C125.143 74.8258 126.244 74.7152 126.363 74.2577Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_197_177738",
    x1: 35.8646,
    y1: 222.5,
    x2: 110.885,
    y2: 219.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_197_177738",
    x1: 111.964,
    y1: 276.021,
    x2: 75.4055,
    y2: 199.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_197_177738",
    x1: 278.997,
    y1: 222.5,
    x2: 203.976,
    y2: 219.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_197_177738",
    x1: 202.897,
    y1: 276.021,
    x2: 239.456,
    y2: 199.924,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3652,
    stopColor: "#605A5C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6066,
    stopColor: "#575154"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8114,
    stopColor: "#494346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9959,
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_197_177738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.587 140.626) rotate(90) scale(89.6106 40.8499)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3765,
    stopColor: "#F3DFC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6253,
    stopColor: "#EED8BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8365,
    stopColor: "#E6CBB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_197_177738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(210.835 10.3314) scale(36.9033 36.947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_197_177738",
    x1: 193.789,
    y1: 28.874,
    x2: 225.499,
    y2: 30.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_197_177738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(104.052 10.3314) rotate(180) scale(36.9032 36.947)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#635D5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5212,
    stopColor: "#615B5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#5A5457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8427,
    stopColor: "#4F494B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9501,
    stopColor: "#3E383B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#332D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_197_177738",
    x1: 121.102,
    y1: 28.874,
    x2: 89.3918,
    y2: 30.4576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_197_177738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(156.397 87.5395) rotate(-90) scale(70.9164 88.0801)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#332D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0363052,
    stopColor: "#352F33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6595,
    stopColor: "#565053"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#635D5F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_197_177738",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(158.161 51.9114) scale(95.8753 95.9889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4E1CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#F3DFC9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7208,
    stopColor: "#EFDAC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8569,
    stopColor: "#E9D0B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9661,
    stopColor: "#E1C3A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9992,
    stopColor: "#DDBD9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_197_177738",
    x1: 157.432,
    y1: 100.944,
    x2: 157.432,
    y2: 87.3088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF669A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6184,
    stopColor: "#FF8AB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9CBD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_197_177738"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 217,
    height: 318,
    fill: "white",
    transform: "translate(51 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSugarGliderSad);
export default __webpack_public_path__ + "static/media/sugarGlider_sad.6045e9fef7791d8252a59561663ce0f1.svg";
export { ForwardRef as ReactComponent };